import axios from 'axios';
import { SERVER_URL } from '../../../Constants';
import { NotesEntity } from '../../../Models/Entities';
import { locationType, noteType, smsDeliveryStatus } from '../../../Models/Enums';

export interface noteInfoDto {
	noteId: string;
	userName: string;
	creationDateTime: Date;
	content: string;
	noteType: noteType;
	locationType: locationType;
	smsDeliveryStatus?: smsDeliveryStatus;
	// Written with nobody signed in (a background task). The note carries the booking owner as its
	// user, so this is what stops it reading as the customer's own action.
	createdBySystem?: boolean;
}
export interface customBookingNoteDto {
	bookingId: string;
	noteContent: string;
}

export interface customUserNoteDto {
	userId: string;
	noteContent: string;
}

export interface AddNoteToFerryTrip {
	ferryTripId: string;
	noteContent: string;
	showToCustomers: boolean;
}

export function getAllNotesForBooking(bookingId: string) {
	const notes = axios
		.get(`${SERVER_URL}/api/entity/NotesEntity/get-all-notes-for-booking?bookingId=${bookingId}`)
		.then(x => x.data);
	return notes;
}

export function getAllNotesForUser(userId: string) {
	const notes = axios
		.get(`${SERVER_URL}/api/entity/NotesEntity/get-all-notes-for-user?userId=${userId}`)
		.then(x => x.data);
	return notes;
}

export function addCustomStaffBookingNote(customNoteInfo: customBookingNoteDto) {
	const notes = axios
		.post(`${SERVER_URL}/api/entity/NotesEntity/add-custom-staff-booking-note`, customNoteInfo)
		.then(x => x.data);
	return notes;
}

export function addCustomStaffUserNote(customNoteInfo: customUserNoteDto) {
	const notes = axios
		.post(`${SERVER_URL}/api/entity/NotesEntity/add-custom-staff-user-note`, customNoteInfo)
		.then(x => x.data);
	return notes;
}

/**
 * Gets all the notes for a ferry trip
 * @param ferryTripId - the ferry trip id of notes to get.
 */
export async function getAllFerryTripNotes(ferryTripId: string, auditNotes: boolean) {
	return axios.get(
		`${SERVER_URL}/api/entity/NotesEntity/get-all-ferry-trip-notes?ferryTripId=${ferryTripId}&auditNotes=${auditNotes}`,
	);
}

/**
 * Saves all notes for a ferry trip. Uses a diff-based approach on the backend:
 * existing notes are updated, missing notes are deleted, and new notes are added.
 */
export async function saveAllNotes(ferryTripId: string, notes: NotesEntity[]) {
	return axios.post(`${SERVER_URL}/api/entity/NotesEntity/save-all-notes?ferryTripId=${ferryTripId}`, notes);
}
